/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Icon as ChakraIcon,
  Flex,
  Input,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Text,
  chakra as C,
} from '@chakra-ui/react';
import styled from '@emotion/styled';
import { CheckTreePicker } from 'rsuite';

import { useJoinGroup } from '../../../api';
import { showNotification } from '../../notification';
import * as Constants from '../../../constants';

const ClassroomSelectWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 15px 0;
  .rs-picker-check {
    flex-grow: 1;
  }
  .rs-picker-toggle-wrapper {
    flex-grow: 1;
    max-width: calc(100% - 40px);
    margin: 0 auto;
  }
`;
interface PickerOption {
  label: string;
  value: string;
  selected?: boolean;
  children?: PickerOption[];
}
interface SonarAcceptModalProps {
  isAcceptInviteModalOpen: boolean;
  onCloseAcceptInviteModal: () => void;
  Styles: Record<string, any>;
  acceptingInvite: any;
  classrooms: any;
  episodeId: string;
}
export const SonarAcceptModal = ({
  isAcceptInviteModalOpen,
  onCloseAcceptInviteModal,
  Styles,
  acceptingInvite,
  classrooms,
  episodeId,
}: SonarAcceptModalProps) => {
  const [pickerList, setPickerList] = useState<PickerOption[]>([]);
  const [selectedPicks, setSelectedPicks] = useState<string[]>([]);
  const {
    mutate: joinGroup,
    isLoading: joinGroupLoading,
    error: joinGroupError,
  } = useJoinGroup(episodeId);

  const resetPickerOptions = () => {
    // const options = [];
    // if (connections && !!connections.active.length) {
    //   options.push({
    //     label: 'Connections',
    //     value: '1',
    //     children: connections.active.map((c: any) => {
    //       const u = c.user_a.id === user.id ? c.user_b : c.user_a;
    //       return {
    //         label: u.username,
    //         value: `ind__${u.id}`,
    //       };
    //     }),
    //   });
    // }
    if (classrooms) {
      const classroomIds = Object.keys(classrooms);
      const options = classroomIds.map((classroomId) => {
        const { classroom, users } = classrooms[classroomId];
        const classroomChildren = users.map((u: any) => {
          return {
            label: u.username,
            value: `class__${u.id}`,
          };
        });
        return {
          label: classroom.name,
          value: classroom.id,
          children: classroomChildren,
        };
      });
      setPickerList([...options]);
    }
  };

  const handlePickerChange = (values: string[]) => {
    const newPicks = values;
    const selectedClassrooms = values.filter(
      (id) => id.indexOf('ind__') === -1 && id.indexOf('class__') === -1
    );
    if (!!selectedClassrooms?.length) {
      selectedClassrooms.forEach((parentClassroomId) => {
        const classroomStudents: string[] = [];
        const classroom = pickerList.find(
          ({ value }) => value === parentClassroomId
        );
        if (classroom?.children) {
          classroom.children.forEach((student) => {
            classroomStudents.push(student.value);
          });
          newPicks.push(...classroomStudents);
        }
      });
    }
    setSelectedPicks([...Array.from(new Set(newPicks))]);
  };

  useEffect(() => {
    if (classrooms) {
      resetPickerOptions();
    }
  }, [classrooms]);

  const onJoinGroup = async () => {
    await joinGroup({
      group_id: acceptingInvite.id,
      invitee_ids: selectedPicks,
    });
    showNotification({
      type: 'success',
      title: 'Group Joined Successfully!',
      message: 'Get excited! Your new learning group has been added below.',
      duration: 3000,
    });
    resetPickerOptions();
    const clearBtn = document.getElementsByClassName(
      'rs-picker-toggle-clean'
    )[0] as HTMLAnchorElement;
    clearBtn?.click();
    onCloseAcceptInviteModal();
  };

  return (
    <Modal
      closeOnOverlayClick={false}
      isOpen={isAcceptInviteModalOpen}
      onClose={onCloseAcceptInviteModal}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Joining Group</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={4}>
          <Box>
            <C.div fontSize="md" textAlign="center">
              You are joining:
            </C.div>
            <Box {...Styles.GroupName}>{acceptingInvite.name}</Box>
            <Text
              w="full"
              textAlign="center"
              fontSize="xs"
              color="gray.700"
              mt="-7px"
            >
              invited by{' '}
              <C.b color="primary.500" fontWeight="semibold">
                {acceptingInvite.user.username}
              </C.b>
            </Text>
            <Box
              borderTop="2px solid"
              borderColor="gray.200"
              as="div"
              fontSize="sm"
              textAlign="center"
              px={3}
              pt={6}
              mt={6}
              fontWeight="normal"
            >
              Select students/classrooms to add to the group:
              <ClassroomSelectWrapper>
                <CheckTreePicker
                  size="lg"
                  uncheckableItemValues={['2']}
                  onChange={handlePickerChange}
                  cascade
                  data={pickerList}
                />
              </ClassroomSelectWrapper>
            </Box>
          </Box>
        </ModalBody>

        <ModalFooter>
          <Button
            // isDisabled={!selectedPicks.length}
            isLoading={!!joinGroupLoading}
            onClick={() => onJoinGroup()}
            colorScheme="primary"
            mr={3}
          >
            Join Group
          </Button>
          <Button onClick={onCloseAcceptInviteModal}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
